<template>
	<div>
		<!-- 登录、注册按钮 -->
		<div class="nav-item nav-item-buttons no-login-toggle" :class="{'right-active':loginCssStatus}">
			<a class="button-default login-btn with-location"  :data-base-url="baceUrl + 'login.html'" href="javascript:void(0);">登录</a>
			<a class="button-light register-btn1 with-location" :data-base-url="baceUrl + 'register.html'" href="javascript:void(0);">注册</a>
		</div>
		<!-- 已登录下拉菜单 -->
		<div class="logined display-none has-login-toggle" :class="{'logined-active':loginCssStatus}">
	    <div class="logined-show">
	        <span><img src="/static/img/user.png" class="user"/></span>
	        <i class="iconfont zhankai">&#xe610;</i>
	        <!-- 这个3先注释掉以后如果要加出来 -->
	        <!-- <em>3</em> -->
	        <ul class="logined-hide display-none">
							<li v-for="item in loginArr">
									<a :href="baceUrl + item.url">
										<span class="iconfont" :class=item.class v-html=item.icon></span><i>{{item.name}}</i>
									</a>
							</li>
	            <!-- 帮助中心和账户设置的分界线 -->
	            <li class="li-division"></li>
	                <!-- 帮助中心和注销登录用相对路径，跨项目的用绝对路径 -->
	            <li>
	                <a href="http://breadoffer.com/aboutus/qa.html">
	                    <span class="iconfont wenhao">&#xe63e;</span><i>帮助中心</i>
	                </a>
	            </li>
	            <li>
	                <a href="http://member.breadoffer.com/logout">
	                    <span class="iconfont tuichudenglu">&#xe644;</span><i>注销登录</i>
	                </a>
	            </li>
	        </ul>
	    </div>
	</div>
</div>
</template>

<script type="text/javascript">
export default{
	props:['loginCssStatus'], // 绑定在搜索页的样式
	data(){
		return{
			 baceUrl:'http://member.breadoffer.com/', // 登录、注册基本路径
			 loginArr:[ //已登录状态下拉数据渲染
				 {icon:'&#xe64e;',class:'gerenxinxi',url:'index.html',name:'会员中心'},
				 {icon:'&#xe64d;',class:'shujiaxuanzhong',url:'coursepool/course.html#sl_1',name:'我的课程'},
				 {icon:'&#xe6a7;',class:'dingdan',url:'coursepool/course.html#sl_2',name:'我的订单'},
				 {icon:'&#xe63f;',class:'youhuima',url:'value/coupon.html',name:'我的优惠'},
				 {icon:'&#xe647;',class:'shezhi',url:'user/info.html',name:'账户设置'},
			 ]
		}
	},
	methods:{
		// 鼠标移入移出效果
		loginFn(){
			$(".logined .logined-show").hover(function () {
					$(this).addClass('active-hover');
					$(this).find('ul').show();
			}, function () {
					$(this).removeClass('active-hover');
					$(this).find("ul").hide();
			});
		}
	},
	mounted(){
		this.loginFn();
	}
}
</script>

<style scoped lang="scss">
@import  "../../sass/mixin";

.nav-item-buttons {
	width: 160px;
	text-align: right;
	a{
		@include border-radius(3px);
		 background-color: #ffffff;
		@include transition(all 0.4s);
	}
	.button-default{
		padding:5px 15px 6px;
		border:1px solid #555555;
		margin-right:15px;
		@include border-radius(3px);
		@include transition(all 0.4s);
		&:hover{
			color:#fff;
			background-color: #555;
			@include transition(all 0.4s);
		}
	}
	.button-light{
		padding:6px 15px;
		background-color: #f8d85d;
		&:hover{
			color:#555;
			background-color: #fdcf3a;
			@include transition(all 0.4s);
		}
	}
}
.right-active{
	margin-left:340px;
}


div.logined{
	float: right;
	position: relative;
	height:60px;
}
.logined-active{
	margin-left:430px;
}
div.logined>div.active-hover{
	/*和超再确定这个地方的透明度*/
	background-color:rgba(53,53,53,0.95);
	/*background:transparent\9;/*/
	/* filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#66363535,endColorstr=#66363535);
	zoom:1\8;
	background: rgba(0,0,0,0.4);   */
}
@media \0screen\,screen\9 {/* 只支持IE6、7、8 */
  div.active-hover{
    background-color:#353535;
    filter:Alpha(opacity=95);
    /*position:static;*/ /* IE6、7、8只能设置position:static(默认属性) ，否则会导致子元素继承Alpha值 */
    *zoom:1; /* 激活IE6、7的haslayout属性，让它读懂Alpha */
  }
  /*.list-cover .alert-text a,.list-cover .alert-text .text-top{*/
    /*position: relative;*//* 设置子元素为相对定位，可让子元素不继承Alpha值 */
  /*} */
}
.logined-show{
	width:76px;
	height:66px;
	line-height: 80px;
	padding-left: 18px;
	cursor: pointer;
	position: relative;
	/*border:1px solid blue;*/
}
.logined-show>em{
	display: inline-block;
	width:13px;
	height:14px;
	background: #f00;
	text-align: center;
	line-height:14px;
	border-radius: 2px;
	font-size:12px;
	position: absolute;
	left:28px;
	top:12px;
	color:#fff;
}
.logined-show>span{
	display: inline-block;
	width:25px;
	height:25px;
	/*background: url(../assets/sprite2.png) no-repeat -394px -25px;*/
	/*vertical-align: middle;*/
}
.user{
	border-radius: 3px;
}
.logined-show .zhankai{
	font-size:18px;
	color:#FFC800;
	position: absolute;
	right:5px;
	bottom:-5px;
}
.logined-hide{
	width:145px;
	position: absolute;
	top:66px;
	right:0px;
	padding-top: 6px;
	z-index: 30;
	border-bottom-left-radius: 3px;
	border-bottom-right-radius: 3px;
	-webkit-box-shadow:0px 2px 3px 0px rgba(0, 0, 0, 0.2);
	-moz-box-shadow:0px 2px 3px 0px rgba(0, 0, 0, 0.2);
	-o-box-shadow:0px 2px 3px 0px rgba(0, 0, 0, 0.2);
	box-shadow:0px 2px 3px 0px rgba(0, 0, 0, 0.2);

	/*和超再确定这个地方的透明度*/
	background-color: rgba(53,53,53,0.95);
}
@media \0screen\,screen\9 {/* 只支持IE6、7、8 */
  .logined-hide{
    background-color:#353535;
    filter:Alpha(opacity=95);
    /*position:static;*/ /* IE6、7、8只能设置position:static(默认属性) ，否则会导致子元素继承Alpha值 */
    *zoom:1; /* 激活IE6、7的haslayout属性，让它读懂Alpha */
  }
  /*.list-cover .alert-text a,.list-cover .alert-text .text-top{*/
    /*position: relative;*//* 设置子元素为相对定位，可让子元素不继承Alpha值 */
  /*} */
}
.logined-hide li{
	width:100%;
	height:24px;
	font-size:12px;
	line-height: 24px;
	margin-bottom:8px;
}
.logined-hide li.li-division{
	width:100%;
	background: #555;
	box-shadow: 0px 2px 1px 0px #333;
	height:1px;
}
.logined-hide li:first-child{
	margin-top:5px;
}
.logined-hide li>a{
	width:100%;
	height:24px;
	display:block;
	color:#fff;
	line-height: 24px;
}
.logined-hide li>a>em{
	display: inline-block;
	width:17px;
	height:17px;
	background: #675943;
	line-height: 17px;
	text-align: center;
	border-radius: 2px;
	margin-left: 20px;
}
.logined-hide li>a:hover{
	background: #FDCF39;
}
.logined-hide li>a:hover span{
	color:#000;
}
.logined-hide li>a:hover i{
	color:#333;
}
.logined-hide li>a>span{
	margin:0px 14px 0px 14px;
}
.logined-hide li>a>span.dingdan{
	font-size: 15px;
}
.logined-hide li>a>i{
}
</style>



// WEBPACK FOOTER //
// login.vue?0ca97ca7